<script setup lang="ts">
// Vendor
import type { Block, Inline, Text } from "@contentful/rich-text-types";

const { nodes } = defineProps<{
  /**
   * The content to render.
   */
  nodes?: (Block | Inline | Text)[];
}>();

/**
 * Map that converts Contentful mark to a valid HTML tag.
 */
const MARKS_MAP: Record<string, string> = {
  bold: "b",
  italic: "i",
  underline: "u",
};
</script>

<template>
  <template v-if="nodes">
    <template v-for="(node, key) in nodes" :key="key">
      <template v-if="node.nodeType === 'text' && node.value">
        <template v-if="node.marks.length">
          <component
            v-for="(mark, key) in node.marks"
            :key="key"
            :is="MARKS_MAP[mark.type]"
          >
            {{ node.value }}
          </component>
        </template>
        <template v-else>
          {{ node.value }}
        </template>
      </template>
      <p v-if="node.nodeType === 'paragraph' && node.content.length">
        <ContentfulNodeRenderer :nodes="node.content" />
      </p>
    </template>
  </template>
</template>
